"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.guidePaymentSuccess = exports.porterGuidePaymentSuccess = exports.onRequestGuide = exports.onViewGuideProfile = exports.onRequestPorterGuide = exports.onEmailSubscription = exports.onSignupSuccess = void 0;

var _types = require("./types");

var onSignupSuccess = function onSignupSuccess(provider) {
  return {
    type: _types.SIGNEDUP_SUCCESS,
    signedUpBy: provider
  };
};

exports.onSignupSuccess = onSignupSuccess;

var onEmailSubscription = function onEmailSubscription() {
  return {
    type: _types.ON_EMAIL_SUBSCRIPTION
  };
};

exports.onEmailSubscription = onEmailSubscription;

var onRequestPorterGuide = function onRequestPorterGuide() {
  return {
    type: _types.CLICKED_ON_REQUEST_PORTER_GUIDE
  };
};

exports.onRequestPorterGuide = onRequestPorterGuide;

var onViewGuideProfile = function onViewGuideProfile() {
  return {
    type: _types.CLICKED_ON_VIEW_GUIDE_PORFILE
  };
};

exports.onViewGuideProfile = onViewGuideProfile;

var onRequestGuide = function onRequestGuide() {
  return {
    type: _types.CLICKED_ON_REQUEST_GUIDE
  };
};

exports.onRequestGuide = onRequestGuide;

var porterGuidePaymentSuccess = function porterGuidePaymentSuccess(amount) {
  return {
    type: _types.PORTER_GUIDE_PAYMENT_SUCCESS,
    amount: amount
  };
};

exports.porterGuidePaymentSuccess = porterGuidePaymentSuccess;

var guidePaymentSuccess = function guidePaymentSuccess(amount) {
  return {
    type: _types.GUIDE_PAYMENT_SUCCESS,
    amount: amount
  };
};

exports.guidePaymentSuccess = guidePaymentSuccess;